import {AuthService} from "../services/auth";
import {Logger} from "../utils/logging";

export class ClientState {
  /**
   *
   * @param {oAuthTokenCollection} authentication - object that holds authentication tokens {accessToken, identityToken, refreshToken}
   */
  static async getCurrentUser (authentication) {
    if (!authentication || !authentication.accessToken) {
      return;
    }

    let currentUser;
    try {
      currentUser = await AuthService.getCurrentUser(authentication.accessToken);
    } catch (e) {
      Logger.log("Failed to get user", e);
    }
    return currentUser;
  };

}
